import { useState } from "react";
import { Search } from "lucide-react";
import { usd, fmtDate } from "@/lib/api";
import { useFetch, PageHeader, Panel, StatusBadge, Table, Empty, Loading, FilterTabs } from "@/components/common";
import { ReviewDialog, ActionBtns } from "@/components/admin";

const SRC = { deposit: "Deposit", trading: "Trading", first_deposit_bonus: "First deposit bonus" };

export default function AdminCommissions() {
  const [status, setStatus] = useState("pending");
  const [program, setProgram] = useState("");
  const [q, setQ] = useState("");
  const [search, setSearch] = useState("");
  const { data, loading, reload } = useFetch(`/admin/commissions?status=${status}&program=${program}&search=${encodeURIComponent(search)}`);
  const [action, setAction] = useState(null);
  const open = (c, kind) => setAction({
    kind, label: "commission", url: `/admin/commissions/${c.id}/${kind}`,
    summary: <>{usd(c.amount)} to <b className="num">{c.earner?.user_code}</b> · {SRC[c.source_type]} from <span className="num">{c.source_user?.user_code}</span> · Ref <span className="num">{c.source_ref}</span></>,
  });
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Admin" title="Commissions" subtitle="Approve or reject referral and YouTuber commissions. Approved amounts are credited to the earner's balance." />
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-wrap gap-2">
          <FilterTabs value={status} onChange={setStatus} options={[["pending", "Pending"], ["approved", "Approved"], ["rejected", "Rejected"], ["", "All"]]} testid="commission-status-filter" />
          <FilterTabs value={program} onChange={setProgram} options={[["", "All programs"], ["referral", "Referral"], ["youtuber", "YouTuber"]]} testid="commission-program-filter" />
        </div>
        <form onSubmit={(e) => { e.preventDefault(); setSearch(q); }} className="flex gap-2">
          <div className="relative"><Search size={15} className="absolute left-3 top-3 text-slate-500" />
            <input className="nx-input w-64 pl-9" placeholder="Search by transaction ID" value={q} onChange={(e) => setQ(e.target.value)} data-testid="commission-search-input" /></div>
          <button className="nx-btn-secondary" data-testid="commission-search-btn">Search</button>
        </form>
      </div>
      <Panel>
        {loading ? <Loading /> : (
          <Table head={["Date", "Program", "Earner", "From user", "Source", "Txn / Ref ID", "Basis", "Rule", "Commission", "Status", ""]} testid="admin-commissions-table">
            {!data?.length && <Empty cols={11} text="No commissions" />}
            {data?.map((c) => (
              <tr key={c.id} data-testid={`commission-row-${c.id}`}>
                <td className="nx-td text-xs">{fmtDate(c.created_at)}</td>
                <td className="nx-td capitalize">{c.program}</td>
                <td className="nx-td num text-[#10B981]">{c.earner?.user_code}</td>
                <td className="nx-td num">{c.source_user?.user_code}</td>
                <td className="nx-td">{SRC[c.source_type]}</td>
                <td className="nx-td num max-w-[180px] truncate text-xs" title={c.source_ref}>{c.source_ref}</td>
                <td className="nx-td num">{usd(c.basis_amount)}</td>
                <td className="nx-td num">{c.rule_type === "flat" ? usd(c.rule_value) : `${c.rule_value}%`}</td>
                <td className="nx-td num font-semibold text-white">{usd(c.amount)}</td>
                <td className="nx-td"><StatusBadge status={c.status} /></td>
                <td className="nx-td">{c.status === "pending" && <ActionBtns id={c.id} onApprove={() => open(c, "approve")} onReject={() => open(c, "reject")} />}</td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
      <ReviewDialog action={action} onClose={() => setAction(null)} onDone={() => { setAction(null); reload(); }} />
    </div>
  );
}
